// Queries used by multiple modules
export const commonQueries = {
  user: () => ['user'],
  profile: () => ['profile'],

  // Document
  documentDownloadAuthorization: (documentId: number) => [
    'document',
    'download-authorization',
    documentId,
  ],

  // Translations
  translationList: () => ['translation/list'],

  // System messages
  systemMessages: () => ['system-messages'],

  // Ecom-policy
  policyList: () => ['ecom-policy/list'],
  customerDepartmentList: (customerId: number) => ['customer/departments', customerId],

  // Admin
  adminUsers: () => ['admin/users'],

  // Subscriptions
  subscriptionSetup: () => ['subscriptions/setup'],

  // Asset-locations
  assetLocationList: () => ['asset-location/list'],
  assetLocationDetails: (id: number) => ['asset-location', id],

  // Employees
  employees: () => ['employees'],
  employeeOffboardingLock: (costObjectId: number) => [
    'employees',
    costObjectId,
    'offboarding-lock',
  ],

  // Leasing
  customerVendorsList: () => ['customer-vendors/list'],
  vendorsByCustomerId: (id: number) => ['customer/vendors', id],
  leasingSettingsByPolicyId: (policyId: number) => ['ecom-policy/leasing/settings', policyId],

  carrierbyid: () => ['carrierById'],

  // Departments
  departmentHead: (departmentId: number) => ['department/head', departmentId],
}
